const normalizeNumber = phone => {
    // normalize number
    phone = phone.replace(/[^\d]/g, '');

    // return formatted number
    return phone ? phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : '';
};

export { normalizeNumber };
